import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/WelcomePage.css'; // Adjust the path if needed
import Header from '../components/Header';
import Footer from '../components/Footer';

const WelcomePage = () => {
  const navigate = useNavigate();

  const handleAdminClick = () => {
    // Navigate to the login page when the button is clicked
    navigate('/login');
  };

  return (
    <div className="page-wrapper">
      <Header />

      <main className="welcome-container">
        <div className="welcome-card">
          <h1 className="welcome-heading">Admin, Welcome to Bio</h1>
          <p className="welcome-text">Manage Bio social app with ease and control.</p>
          <button className="admin-button" onClick={handleAdminClick}>
            Admin Access
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default WelcomePage;
